/**
 * Reverse geocode (lat, lng) to an address using OpenStreetMap Nominatim.
 * See https://operations.osmfoundation.org/policies/nominatim/ for usage policy.
 */
export async function reverseGeocode(
  lat: number,
  lng: number
): Promise<string> {
  const params = new URLSearchParams({
    lat: String(lat),
    lon: String(lng),
    format: "json",
  });
  const res = await fetch(
    `https://nominatim.openstreetmap.org/reverse?${params}`,
    {
      headers: {
        "User-Agent": "AlnarpsAgroecologyFarm/1.0 (pickup location map)",
      },
    }
  );
  if (!res.ok) throw new Error("Reverse geocode failed");
  const data = (await res.json()) as { display_name?: string };
  return data.display_name ?? `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
}
